<template lang="pug">
  div(class="share-link-socials")
    div(
      v-if="showLabel"
      class="text-12px dark mb-4"
    ) {{ $t('Share via') }}
    div(class="share-link-socials__buttons")
      div(
        v-for="shareBtn in shareButtons"
        :key="shareBtn.key"
        class="share-link-socials__btn-wrapper"
      )
        v-btn(
          class="share-link-socials__btn"
          icon
          :loading="shareBtn.loading"
          @click="shareBtn.click"
          :data-test="shareBtn.dataTest"
        )
          img(
            :src="shareBtn.icon"
            :alt="shareBtn.key"
            class="share-link-socials__logo"
          )
        div(class="text-10px fw-300 dark") {{ shareBtn.text }}
        div(
          v-if="shareBtn.inDevelopment"
          class="share-link-socials__coming-soon"
        ) {{ $t('Soon') }}
</template>

<script>
export default {
  name: 'BlockDocumentShareLinkSocials',
  props: {
    showLabel: {
      type: Boolean,
      default: true
    },
    copyLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    shareButtons() {
      return [
        {
          key: 'copy',
          icon: require('~/assets/sprite/svg/copy-circle-gray.svg'),
          text: this.$t('Copy'),
          dataTest: 'share-copy-link-btn',
          inDevelopment: false,
          loading: this.copyLoading,
          click: () => this.$emit('copy')
        },
        {
          key: 'whatsapp',
          icon: require('~/assets/images/icons/whatsapp-logo.png'),
          text: 'WhatsApp',
          dataTest: 'share-whatsapp-btn',
          inDevelopment: false,
          loading: false,
          click: () => this.$emit('shareMessenger', 'whatsapp')
        },
        {
          key: 'telegram',
          icon: require('~/assets/images/icons/telegram-logo.png'),
          text: 'Telegram',
          dataTest: 'share-telegram-btn',
          inDevelopment: false,
          loading: false,
          click: () => this.$emit('shareMessenger', 'telegram')
        },
        {
          key: 'viber',
          icon: require('~/assets/images/icons/viber-logo.png'),
          text: 'Viber',
          dataTest: 'share-viber-btn',
          inDevelopment: false,
          loading: false,
          click: () => this.$emit('shareMessenger', 'viber')
        },
        {
          key: 'SMS',
          icon: require('~/assets/images/icons/sms-logo.png'),
          text: 'SMS',
          dataTest: 'share-sms-btn',
          inDevelopment: true,
          loading: false,
          click: () => this.$emit('sms')
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.share-link-socials {
  &__buttons {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  &__btn {
    width: 40px;
    height: 40px;
    transition: transform 0.2s;

    &:hover {
      transform: scale(1.05);
    }
  }
  &__logo {
    width: 40px;
    height: 40px;
    object-fit: contain;
  }
  &__btn-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }
  &__coming-soon {
    position: absolute;
    top: -10px;
    right: -36px;
    background-color: $background-gray;
    color: #ffa04c;
    border-radius: 20px;
    padding: 4px 8px;
    font-size: 10px;
    font-weight: 400;
    white-space: nowrap;
    pointer-events: none;
  }
}
</style>
